import {
  ContactFormValues,
  HomeFormValues,
  DeliveryFormValues,
  MarketingBlackListFormValues,
} from '@/forms/HomeForm'
import axios from 'axios'

const FormDelivery = async (values: DeliveryFormValues) => {
  const {data} = await axios.post(
    process.env.NEXT_PUBLIC_API_URL + '/leads_form/delivery',
    values,
  )
  return data
}
const FormRequest = async (values: HomeFormValues) => {
  const {data} = await axios.post(
    process.env.NEXT_PUBLIC_API_URL + '/leads_form/request',
    values,
  )
  return data
}

const FormBlackList = async (values: MarketingBlackListFormValues) => {
  const {data} = await axios.post(
    process.env.NEXT_PUBLIC_API_URL + '/sms/blacklist_add',
    values,
  )
  return data
}
const FormContact = async (values: ContactFormValues) => {
  const {data} = await axios.post(
    process.env.NEXT_PUBLIC_API_URL + '/leads_form/contact',
    values,
  )
  return data
}

export {FormRequest, FormContact, FormDelivery, FormBlackList}
